/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
let SalesforceConfig = {
   displayLabels: {
        identifier : {
            name: 'id',
            label: 'Ticket ID',
        },
        modules : [
            {
                name: 'sub_module',
                label: 'Sub Module'
            },
            {
                name: 'main_module',
                label: 'Main Module'
            },
        ],
        issue : [
            {
                name: 'title',
                label: 'Issue'
            },
            {
                name: 'description',
                label: 'Description'
            }
        ],
    },
    ticketTypes: ["resolve", "recommendation", "queue"],
    result: { 
        "id": "A25S35", 
        "title": "Unable to sync Airpods to Ubuntu",
        "description": "I tried connecting to Airpods in UBbuntu and thats not working.<br/>I tried connecting to Airpods in UBbuntu and thats not working.<br/><br/>.I tried connecting to Airpods in UBbuntu and thats not working.<br/><br/><br/><br/>connecting to Airpods in UBbuntu and thats not working.connecting to Airpods in UBbuntu and thats not working.",
        
        "resolution": "Change bluetooth config file and <br/><br/><br/><br/><br/> restart the services",
        "classes" : {
            "category": "IT Support",
            "subCategory": "Application Support",
            "department": "Product",
            "taskType": "Recommendation Text and Remediation",
            "mainModule": "Main Module",
            "subModule": "Sub Module"
        }
    }
}

let ServicenowConfig = {
    displayLabels: {
        identifier : {
            name: 'id',
            label: 'Ticket ID',   
        },
        modules : [
            {
                name: 'category',
                label: 'Category'
            },
            {
                name: 'subCategory',
                label: 'Sub Category'
            },
            {
                name: 'module',
                label: 'Main Module'
            },
            {
                name: 'department',
                label: 'Department'
            },
            {
                name: 'taskType',
                label: 'Task Type'
            }
        ],
        issue : [
            {
                name: 'title',
                label: 'Issue'
            },
            {
                name: 'description',
                label: 'Details'
            }
        ],
        resolution: [
            {
                name: 'ticket_resolution',
                label: 'Resolution',
            },
            {
                name: 'notes',
                label: 'Notes',
            }
        ],
 
    },
    ticketTypes: ["resolve", "recommendation", "queue"],
    result: { 
        "id": "GT5S35", 
        "title": "Unable to sync Airpods to Ubuntu",
        "description": "I tried connecting to Airpods in UBbuntu and thats not working.<br/>I tried connecting to Airpods in UBbuntu and thats not working.<br/><br/>.I tried connecting to Airpods in UBbuntu and thats not working.<br/><br/><br/><br/>connecting to Airpods in UBbuntu and thats not working.connecting to Airpods in UBbuntu and thats not working.",
        "notes": "Displaying sample notes",
        "resolution": "Change bluetooth config file and \n\n\n\n\n restart the services",
        "classes" : {
            "category": "IT Support",
            "subCategory": "Application Support",
            "department": "Product",
            "taskType": "Recommendation Text and Remediation",
            "mainModule": "Main Module",
            "subModule": "Sub Module"
        },
    }
 }



export { SalesforceConfig, ServicenowConfig };